export const REGIONS = {
  AP: "AP",
  UK: "UK",
  CANADA: "Canada",
  MNC: "MNC",
  CSP: "CSP",
  MARKETING: "Marketing",
  MEXICO: "Mexico",
  UK_ENTERPRISE: "UK Enterprise",
  CSP_LATAM: "CSP LATAM",
};

export const FORM_LABELS = {
  EN: {
    FORM_TITLE_NOTE:
      "Complete this form with true, complete and accurate information so that access request will be granted without delay.",
    USER_INFORMATION: {
      FORM_TITLE: "User Information",
      GPN_ID: "GPN ID/Login",
      EMAIL: "Email",
      NAME: "Name",
      DEPARTMENT: "Department",
      GEOGRAPHY: "Geography",
      TIMEZONE: "Timezone",
      CURRENCY: "Currency",
    },
    SETUP_TYPE: {
      FORM_TITLE: "Setup Type",
      NEW_USER: "New User Setup",
      REDUCING: "Reducing Access",
      ADDITIONAL: "Additional Access / Access Modification",
      DEACTIVATE: "Deactivate User",
      REACTIVATE: "Reactivate User",
    },
    ENVIRONMENT: {
      FORM_TITLE: "Environment",
      QA: "QA",
      CERT: "CERT",
      PRODUCTION: "Production",
    },
    INSIDE_SALES_REP: {
      FORM_TITLE: "Inside Sales Rep Information",
      FORM_NOTE:
        "Only fill out this section if the CA/UK user will require integration",
      FIRST_NAME: "First Name",
      LAST_NAME: "Last Name",
      PHONE_NUMBER: "Phone Number",
      MOSS_SALES_UNIT: "MOSS Sales Unit",
      REP_CODE_ISR: "Rep Code of ISR",
      REP_CODE_USER: "Rep Code of User",
      SALES_CHANNEL_UK: "Sales Channel (UK)",
      SALES_CHANNEL_CODE: "Sales Channel Code",
    },
    ROLE_PERSONA_ASSIGNMENT: {
      FORM_TITLE: "Role and Persona Assignment",
      FORM_NOTE:
        'Note: If you select User Type - "Sales Profile with CSP Access" , the user will be assigned the Sales Profile and granted the Hybrid CSP Permission Set, these will be known as "Hybrid users". This access requires additional approval from the Application Owner or Director, and a reason or purpose for Hybrid Access is necessary.',
      USER_TYPE: "User Type",
      USER_TYPE_TOOLTIP: "",
      PERSONA: "Persona",
      PERSONA_TOOLTIP: "",
      ROLE: "Role",
      ROLE_TOOLTIP: "",
      PURPOSE_OF_HYBRID_ACCESS: "Purpose of Hybrid Access",
      PURPOSE_OF_HYBIRD_ACCESS_PLACEHOLDER: "Write details here",
      ACCESS_MIRROR_FROM: "Access to Be Mirrored From (Name & Email)",
      ACCESS_MIRROR_FROM_CAPTION:
        "Note: Not applicable for user deactivation. Enter NA.",
    },
    GROUP_ASSIGNMENT: {
      FORM_TITLE: "Group/Queue Assignments",
      FORM_NOTE:
        "If a user needs additional access, please specify the relevant Regional Alignment Groups or Queues according to the user’s assigned region.",
    },
    MANAGER_APPROVAL: {
      FORM_TITLE: "",
      NAME: "Name",
      DATE: "Date",
      SIGNATURE: "Signature",
    },
    ADDITIONAL_COMMENTS: {
      LABEL: "Additional Comments",
    },
  },
  ESP: {
    FORM_TITLE_NOTE:
      "Por favor complete este formulario con información verdadera, completa y precisa para que la solicitud de acceso sea otorgada sin demora.",
    USER_INFORMATION: {
      FORM_TITLE: "INFORMACIÓN DEL USUARIO",
      GPN_ID: "ID GPN/Inciar Sesión",
      EMAIL: "Correo Electrónico",
      NAME: "Nombre",
      DEPARTMENT: "Departamento",
      GEOGRAPHY: "Geografía",
      TIMEZONE: "Zona Horaria",
      CURRENCY: "Divisa",
    },
    SETUP_TYPE: {
      FORM_TITLE: "TIPO DE CONFIGURACIÓN",
      NEW_USER: "Configuración de nuevo usuario",
      REDUCING: "Reduciendo el acceso ",
      ADDITIONAL: "Acceso Adicional / Modificación de Acceso",
      DEACTIVATE: "Desactivar Usuarios",
      REACTIVATE: "Reactivar",
    },
    ENVIRONMENT: {
      FORM_TITLE: "ENTORNO",
      QA: "QA",
      CERT: "CERT",
      PRODUCTION: "Production",
    },
    INSIDE_SALES_REP: {
      FORM_TITLE:
        "Información del representante de ventas interno (SOLO PARA USUARIOS DE CANADÁ Y EL REINO UNIDO)",
      FORM_NOTE:
        "Complete esta sección solo si el usuario de CA/Reino Unido requerirá INTEGRACIÓN",
      FIRST_NAME: "Nombre",
      LAST_NAME: "Apellido",
      PHONE_NUMBER: "Número de teléfono",
      MOSS_SALES_UNIT: "Unidad de venta MOSS",
      REP_CODE_ISR: "ISR código de ejecutivo",
      REP_CODE_USER: "Codigo de ejec del Usuario",
      SALES_CHANNEL_UK: "Canal de Ventas (Reino Unido)",
      SALES_CHANNEL_CODE: "Código de canal de ventas",
    },
    ROLE_PERSONA_ASSIGNMENT: {
      FORM_TITLE: "Asignación de roles y perfiles (especifique)",
      FORM_NOTE:
        'Nota: Si selecciona el tipo de usuario "Perfil de ventas con acceso a CSP", se le asignará al usuario el perfil de ventas y se le otorgará el conjunto de permisos de CSP híbrido; estos usuarios se conocerán como "usuarios híbridos". Este acceso requiere la aprobación adicional del propietario o director de la aplicación, y es necesario un motivo o propósito para el acceso híbrido.',
      USER_TYPE: "Tipo de Usario",
      USER_TYPE_TOOLTIP: "",
      PERSONA: "Persona",
      PERSONA_TOOLTIP: "",
      ROLE: "Role",
      ROLE_TOOLTIP: "",
      PURPOSE_OF_HYBRID_ACCESS: "Propósito del acceso híbrido",
      PURPOSE_OF_HYBIRD_ACCESS_PLACEHOLDER: "Escribe detalles aquí",
      ACCESS_MIRROR_FROM:
        "Acceso a reflejar desde (Nombre y correo electrónico)",
      ACCESS_MIRROR_FROM_CAPTION:
        "Nota: No aplicable para desactivación de usuario. Ingrese NA.",
    },
    GROUP_ASSIGNMENT: {
      FORM_TITLE: "Asignaciones de grupos/colas (especifique)",
      FORM_NOTE:
        "Nota: Si un usuario necesita acceso adicional, especifique los grupos de alineación regionales o colas relevantes según la región asignada al usuario.",
    },
    MANAGER_APPROVAL: {
      FORM_TITLE:
        "Aprobación del gerente (es decir, la persona que presenta la solicitud)",
      NAME: "Nombre",
      DATE: "Fecha",
      SIGNATURE: "Firma",
    },
    ADDITIONAL_COMMENTS: {
      LABEL: "Comentarios Adicionales",
    },
  },
};

export const TIMEZONE_OPTIONS = [
  "GMT+14:00 - Line Is. Time (Pacific/Kiritimati)",
  "GMT+13:00 - Phoenix Is. Time (Pacific/Enderbury)",
  "GMT+13:00 - Tonga Time (Pacific/Tongatapu)",
  "GMT+12:45 - Chatham Standard Time (Pacific/Chatham)",
  "GMT+12:00 - New Zealand Time (Pacific/Auckland)",
  "GMT+12:00 - Fiji Time (Pacific/Fiji)",
  "GMT+12:00 - Petropavlovsk-Kamchatski Time (Asia/Kamachatka)",
  "GMT+11:30 - Norfolk Time (Pacific/Norfolk)",
  "GMT+11:00 - Lord Howe Standard Time (Australia/Lord_Howe)",
  "GMT+11:00 - Solomon Is. Time (Pacific/Guadalcanal)",
  "GMT+10:30 - Australian Central Standard Time ((South Australia) Australia/Adelaide)",
  "GMT+10:00 - Australian Eastern Standard Time (New South Wales)(Australia/Brisbane)",
  "GMT+10:00 - Australian Eastern Standard Time (Queensland)(Australia/Brisbane)",
  "GMT+09:30 - Australian Central Standard Time (Northern Territory)(Australia/Darwin)",
  "GMT+09:00 - Korea Standard Time (Asia/Seoul)",
  "GMT+09:00 - Japan Standard Time (Asia/Toyko)",
  "GMT+08:00 - Hong Kong Time (Asia/Hong_Kong)",
  "GMT+08:00 - Malyasia Time (Asia/Kuala_Lumpur)",
  "GMT+08:00 - Philippines Time (Asia/Manila)",
  "GMT+08:00 - China Standard Time (Asia/Shangai)",
  "GMT+08:00 - Singapore Time (Asia/Singapore)",
  "GMT+08:00 - China Standard Time (Asia/Taipei)",
  "GMT+08:00 - Australian Western Standard time (Australia/Perth)",
  "GMT+07:00 - Indochina Time (Asia/Bangkok)",
  "GMT+07:00 - Indochina Time (Asia/Ho_Chi_Minh)",
  "GMT+07:00 - West Indonesia Time (Asia/Jakarta)",
  "GMT+06:30 - Myanmar Time (Asia/Rangoon)",
  "GMT+06:00 - Bangladesh Time (Asia/Dhaka)",
  "GMT+05:45 - Nepal Time (Asia/Kathmandu)",
  "GMT+05:30 - India Standard Time (Asia/Colombo)",
  "GMT+05:30 - India Standard Time (Asia/Kolkata)",
  "GMT+05:00 - Pakistan Time (Asia/Karachi)",
  "GMT+05:00 - Uzbekistan Time (Asia/Tashkent)",
  "GMT+05:00 - Yekateringburg Time (Asia/Yekaterinburg)",
  "GMT+04:30 - Afghanistan Time (Asia/Kabul)",
  "GMT+04:00 - Azerbaijan Summer Time (Asia/Baku)",
  "GMT+04:00 - Gulf Standard Time (Asia/Dubai)",
  "GMT+04:00 - Georgia Time (Asia/Tbilisi)",
  "GMT+04:00 - Armenia Time (Asia/Yerevan)",
  "GMT+03:30 - Iran Daylight Time (Asian/Tehran)",
  "GMT+03:30 - East African Time (Africa/Nairobi)",
  "GMT+03:00 - Arabia Standard Time (Asia/Baghdad)",
  "GMT+03:00 - Arabia Standard Time (Asia/Kuwait)",
  "GMT+03:00 - Arabia Standard Time (Asia/Riyadh)",
  "GMT+03:00 - Moscow Standard Time (Europe/Minsk)",
  "GMT+03:00 - Moscow Standard Time (Europe/Moscow)",
  "GMT+03:00 - Eastern European Summer Time (Africa/Cairo)",
  "GMT+03:00 - Eastern European Summer Time (Asia/Beirut)",
  "GMT+03:00 - Israel Daylight Time (Asia/Jerusalem)",
  "GMT+03:00 - Eastern European Summer Time (Europe/Athens)",
  "GMT+03:00 - Eastern European Summer Time (Europe/Bucharest)",
  "GMT+03:00 - Eastern European Summer Time (Europe/Helsinki)",
  "GMT+03:00 - Eastern European Summer Time (Europe/Istanbul)",
  "GMT+02:00 - South Africa Standard Time (Africa/Johannesburg)",
  "GMT+02:00 - Central European Summer Time (Europe/Amsterdam)",
  "GMT+02:00 - Central European Summer Time (Europe/Berlin)",
  "GMT+02:00 - Central European Summer Time (Europe/Brussels)",
  "GMT+02:00 - Central European Summer Time (Europe/Paris)",
  "GMT+02:00 - Central European Summer Time (Europe/Prague)",
  "GMT+02:00 - Central European Summer Time (Europe/Rome)",
  "GMT+02:00 - Western European Summer Time (Europe/Lisbon)",
  "GMT+01:00 - Central European Time (Africa/Algiers)",
  "GMT+01:00 - British Summer Time (Europe/London)",
  "GMT-01:00 - Cape Verde Time (Atlantic/Cape_Verde) ",
  "GMT+00:00 - Western European Time (Africa/Casablanca)",
  "GMT+00:00 - Irish Summer Time (Europe/Dublin)",
  "GMT+00:00 - Greenwich Mean Time (GMT)",
  "GMT-00:00 - Eastern Greenland Summer Time (America/Scoresbysund)",
  "GMT-00:00 - Azores Summer Time (Atlantic/Azores) ",
  "GMT-02:00 - South Georgia Standard Time (Atlantic/South_Georgia) ",
  "GMT-02:30 - Newfoundland Daylight Time (America/St_Johns)",
  "GMT-03:00 - Brasilia Summer Time (America/Sao_Paulo)",
  "GMT-03:00 - Argentina Time (America/Argentina/Buenos Aires)",
  "GMT-03:00 - Chile Summer Time (America/Santiago)",
  "GMT-03:00 - Atlantic Daylight Time (America/Halifax)",
  "GMT-04:00 - Atlantic Standard Time (America/Puerto_Rico)",
  "GMT-04:00 - Atlantic Daylight Time (Atlantic/Bermuda)",
  "GMT-04:30 - Venezuela Time (America/Caracas)",
  "GMT-04:00 - Eastern Daylight Time (America/Indiana/Indianapolis)",
  "GMT-04:00 - Eastern Daylight Time (America/New_York)",
  "GMT-05:00 - Colombia Time (America/Bogota)",
  "GMT-05:00 - Peru Time (America/Lima)",
  "GMT-05:00 - Eastern Standard Time (America/Panama)",
  "GMT-05:00 - Central Daylight Time (America/Mexico_City)",
  "GMT-05:00 - Central Daylight Time (America/Chicago)",
  "GMT-06:00 - Central Standard Time (America/El_Salvador)",
  "GMT-06:00 - Mountain Daylight Time (America/Denver)",
  "GMT-06:00 - Mountain Standard Time (America/Mazatlan)",
  "GMT-07:00 - Mountain Standard Time (America/Phoenix)",
  "GMT-07:00 - Pacific Daylight Time (America/Los_Angeles)",
  "GMT-07:00 - Pacific Daylight Time (America/Tijuana)",
  "GMT-08:00 - Pitcairn Standard Time (Pacific/Pitcairn)",
  "GMT-08:00 - Alaska Daylight Time (America/Anchorage)",
  "GMT-09:00 - Gambier Time (Pacific/Gambier)",
  "GMT-09:00 - Hawaii-Aleutian Standard Time (America/Adak)",
  "GMT-09:30 - Marquesas Time (Pacific/Marquesas)",
  "GMT-10:00 - Hawaii-Aleutian Standard Time (Pacific/Honolulu)",
  "GMT-11:00 - Niue Time (Pacific/Niue)",
  "GMT-11:00 - Samoa Standard Time (Pacific/Pago_Pago)",
];

export const CURRENCY_OPTIONS = [
  "CAD - Canadian Dollar",
  "CNY - Chinese Yuan",
  "EUR - Euro",
  "GBP - British Pound",
  "HKD - Hong Kong Dollar",
  "INR - Indian Rupee",
  "LKR - Sri Lanka Rupee",
  "MOP - Macau Pataca",
  "MXN - Mexican Peso",
  "MYR - Malyasian Ringgit",
  "PHP - Philippine Peso",
  "SGD - Singapore Dollar",
  "TWD - Taiwan Dollar",
  "USD - U.S. Dollar",
];

export const CURRENCY_OPTIONS_UK_ENTERPRISE = [
  "EUR - Euro",
  "GBP - British Pound",
];

export const GEOGRAPHY_OPTIONS: Record<string, string[]> = {
  AP: [
    "Hong Kong",
    "China",
    "Macau",
    "Malaysia",
    "Maldives",
    "India",
    "Philippines",
    "Singapore",
    "Sri Lanka",
    "Brunei",
    "Taiwan",
  ],
  Mexico: [
    "United States",
    "Canada",
    "Brunei",
    "India",
    "Hong Kong",
    "China",
    "Macau",
    "Malaysia",
    "Maldives",
    "Mexico",
    "Philippines",
    "Singapore",
    "Sri Lanka",
    "United Kingdom",
    "Global",
  ],
  Canada: ["Canada"],
  CSP: [
    "United States",
    "Canada",
    "Brunei",
    "India",
    "Hong Kong",
    "China",
    "Macau",
    "Malaysia",
    "Maldives",
    "Mexico",
    "Philippines",
    "Singapore",
    "Sri Lanka",
    "United Kingdom",
    "Global",
  ],
  "CSP LATAM": [
    "United States",
    "Canada",
    "Brunei",
    "India",
    "Hong Kong",
    "China",
    "Macau",
    "Malaysia",
    "Maldives",
    "Mexico",
    "Philippines",
    "Singapore",
    "Sri Lanka",
    "United Kingdom",
    "Global",
  ],
  Marketing: [
    "United States",
    "Canada",
    "Brunei",
    "India",
    "Hong Kong",
    "China",
    "Macau",
    "Malaysia",
    "Maldives",
    "Mexico",
    "Philippines",
    "Singapore",
    "Sri Lanka",
    "United Kingdom",
    "Global",
  ],
  MNC: ["Global"],
  "UK Enterprise": ["United Kingdom"],
  UK: ["United Kingdom"],
};

export const MEXICO_OPTIONS = {
  MOSS_SALES_UNIT: [
    "1000 (GP)",
    "2000 (DJ)",
    "9000 (GP Sales acceleration DSR/DMs)",
  ],
  SALES_CHANNEL_UK: [
    "Global",
    "Telesales",
    "General Sales",
    "Major Accounts",
    "Annecto",
    "Co-op (ESA)",
    "Payzone (ESA)",
    "National Accounts",
    "Others",
    "Inside Sales",
    "PayVector(ISO)",
    "Acceptacard (ISO)",
    "WisePay",
    "PaymentSense(ISO)",
    "RMS (ISO)",
    "Yorkshire Payments",
    "Annecto1",
    "NETPAY",
    "NETPAY BG",
    "UK Direct Sales",
    "Realex",
    "Transax",
    "Active Payments",
    "Bleep",
    "ISOA",
    "ISOB",
    "ISOC",
    "Intuit",
    "Global mPOS",
  ],
  SALES_CHANNEL_CODE: [
    "000-No Channel",
    "001-SME Payment Direct-GPN",
    "002-Xenial SMB Payment Direct-GPN",
    "003-SME-HPY",
    "004-Dealer Channel-GPN",
    "005-NWS",
    "006-Self Select-GPN",
    "009-National/Premier-GPN",
    "011-National/Premier-HPY",
    "014-MNC",
    "015-Payment Processing Sales",
    "016-ISO",
    "017-Agent",
    "018-Bank",
    "019-SME Payroll Direct",
    "020-Elavon",
    "021-Indirect",
    "022-Dealer Channel-HPY",
    "023-Self Select-HPY",
    "024-Enterprise Payroll Direct",
    "025-Other Payment & Payroll Services",
    "031-Open Edge",
    "033-Greater Giving",
    "034-Other Integrated Solutions and Vertical Markets",
    "035-Gaming and Check",
    "039-Heartland School Solutions",
    "040-MicroPayments",
    "041-Active Sports",
    "042-Active Communities-Outside",
    "043-Active Communities-Inside",
    "047-Active Other",
    "048-Active Corporate",
    "050-Xenial Enterprise Direct",
    "051-ECSI",
    "052-Touchnet",
    "053-OneCard",
    "059-Xenail SMB Payment Dreict-HPY",
    "071-EZIDebit",
    "073-Storman",
    "078-Eway",
    "079-International Acquiring",
    "083-Issuing",
    "085-Third Party",
    "089-Other Channel",
  ],
};

export const CAPTIONS = {
  ROLE_CAPTION: {
    GLOBAL:
      "Please refer to this link for the Role Hierarchy: https://docs.google.com/spreadsheets/d/1nE5-eTBuU7gNgZLMEaHVvcZsI3LOWmdyKkkWy_licW4/edit?gid=920761246#gid=920761246",
    MEXICO:
      "Consulte este enlace para conocer la jerarquía de roles: https://docs.google.com/spreadsheets/d/1nE5-eTBuU7gNgZLMEaHVvcZsI3LOWmdyKkkWy_licW4/edit?gid=920761246#gid=920761246",
  },
};
